import { createContext } from "react";

export const UpdateBoundaryContext = createContext(null);
